export default __webpack_public_path__ + "static/media/granville16.9e1cb789.jpg";